function applyRefineByChange(state, opened) {
  const { filters = [] } = state.navWithFilters;
  return {
    ...state,
    mobileRefineByOpened: opened,
    clusterCollapse: opened,
    navWithFilters: {
      ...state.navWithFilters,
      filters: filters.map(filter => ({ ...filter, collapse: opened })),
    },
  };
}

export function openMobileRefineBy({ state }) {
  return applyRefineByChange(state, true);
}

export function closeMobileRefineBy({ state }) {
  return applyRefineByChange(state, false);
}
